// Query kalitlari — bitta joyda, aks holda bir xil ma'lumot ikki xil kalit
// ostida keshlanib, biri yangilanganda ikkinchisi eskirib qoladi.
//
// ⚠️ Kassa ekranining O'Z kalitlari `features/cashdesk/cashdeskKeys.ts`
// da — ular tez-tez o'zgaradi va shu ekran bilan birga yashaydi.
export const queryKeys = {
  me: ['partner', 'me'] as const,
}
